import get from "lodash.get";

import Abilities from "services/permissions/abilities";
import UserActioner from "services/user/actioner";

class PermissionsActioner {
  hasAccess = (name, subject) => async (dispatch, getState) => {
    const me = get(getState(), "User", {});
    const currentContract = getState()?.Contract?.contract;

    if (!me.initialized) {
      return false;
    }
    if (Abilities.initialized) {
      return Abilities.ability.can(name, subject);
    }

    if (currentContract?.id) {
      await dispatch(UserActioner.initDataFromContractId(currentContract?.id));
    } else {
      await dispatch(UserActioner.initDataForDefaultContract());
    }

    return dispatch(this.hasAccess(name, subject));
  };
}

export default new PermissionsActioner();
